import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PAGES } from '../../dynamic-details.constants';

@Component({
  selector: 'cm-form-confirm-content',
  templateUrl: './form-confirm-content.component.html',
  styleUrls: ['./form-confirm-content.component.scss'],
})
export class DynamicFormConfirmComponent {
  @Input() step;
  @Output() screenChange: EventEmitter<string> = new EventEmitter();
  @Output() confirm: EventEmitter<any> = new EventEmitter();

  constructor() {}

  backToPreviousPage() {
    this.screenChange.emit(PAGES.BACK);
  }
}
